import { render, staticRenderFns } from "./ProjectOverview.vue?vue&type=template&id=983e9408&scoped=true&"
import script from "./ProjectOverview.vue?vue&type=script&lang=js&"
export * from "./ProjectOverview.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "983e9408",
  null
  
)

export default component.exports